import { ActionContext } from "vuex";
import { LoggerService as lgg } from "vue-components-library";

import { WelcomeResponse } from "./WelcomeResponse";
import { UsersService } from "@/Users/services";

const LOG_TAG = "[USERS STORE]";

const StatusCodes = {
  OK: 200
};

function getDefaultState() {
  return {
    data: {},
    selectedItem: null
  };
}

function augmentData(data: any, anObject: Object) {
  if (data === undefined) {
    return [];
  }
  return data.map((item: any) => Object.assign(item, anObject));
}

const state = getDefaultState();

const getters = {
  data: (state: any) => state.data,
  selectedItem: (state: any) => state.selectedItem,
  totalItems: (state: any) => state.data.length,
  users: (state: any) =>
    augmentData(state.data.administrators, { role: "Administrator", isEmsAdmin: true }).concat(
      augmentData(state.data.members, { role: "Member", isEmsAdmin: false })
    ),
  memberCount: (state: any) =>
    (state.data.administrators ? state.data.administrators.length : 0) +
    (state.data.members ? state.data.members.length : 0),
  thisItem: (state: any) => {
    if (!state.selectedItem) {
      return null;
    }
    return state.data.filter((item: any) => item.id === state.selectedItem)[0];
  }
};

export const actions = {
  selectItem(context: ActionContext<any, any>, id: String) {
    context.commit("SELECT_ITEM", id);
  },
  async loadData(context: ActionContext<any, any>, emsAgencyId: String) {
    try {
      context.dispatch("Global/loading", null, { root: true });
      const data = await UsersService.getData(emsAgencyId);
      context.commit("SET_DATA", data);
      context.dispatch("Global/doneLoading", null, { root: true });
    } catch (error) {
      lgg.error(`${LOG_TAG} Failed to load Users`, { error });
    }
  },
  async insertData(context: ActionContext<any, any>, payload: any) {
    try {
      const { emsAgencyId, body } = payload;
      context.dispatch("Global/loading", null, { root: true });
      await UsersService.insertData(body).catch(() => context.commit("DONE_LOADING"));
      context.dispatch("Global/doneLoading", null, { root: true });
      context.dispatch("loadData", emsAgencyId);
    } catch (error) {
      lgg.error(`${LOG_TAG} Failed to create User`, { error });
    }
  },
  async updateData(context: ActionContext<any, any>, payload: any) {
    try {
      const { emsAgencyId, recordId: userId, body } = payload;
      context.dispatch("Global/loading", null, { root: true });
      await UsersService.updateData(userId, body).catch(() => context.commit("DONE_LOADING"));
      context.dispatch("Global/doneLoading", null, { root: true });
      context.dispatch("loadData", emsAgencyId);
    } catch (error) {
      lgg.error(`${LOG_TAG} Failed to update User`, { error });
    }
  },
  async removeData(context: ActionContext<any, any>, payload: any) {
    try {
      const { emsAgencyId, recordId, role } = payload;
      context.dispatch("Global/loading", null, { root: true });
      await UsersService.deleteData(emsAgencyId, recordId, role);
      context.dispatch("Global/doneLoading", null, { root: true });
      context.dispatch("loadData", emsAgencyId);
    } catch (error) {
      lgg.error(`${LOG_TAG} Failed to remove User`, { error });
    }
  },
  async addExistingUser(context: ActionContext<any, any>, payload: any) {
    try {
      const { emsAgencyId, recordId, role } = payload;
      context.dispatch("Global/loading", null, { root: true });
      await UsersService.addExistingUser(emsAgencyId, recordId, role);
      context.dispatch("Global/doneLoading", null, { root: true });
      context.dispatch("loadData", emsAgencyId);
    } catch (error) {
      lgg.error(`${LOG_TAG} Failed to add existing User`, { error });
    }
  },
  refresh(context: ActionContext<any, any>, emsAgencyId: String) {
    context.dispatch("loadData", emsAgencyId);
  },
  async resendWelcomeEmail(context, { username }): Promise<WelcomeResponse> {
    try {
      const response = await UsersService.sendWelcomeEmail({
        username
      });
      lgg.info(`${LOG_TAG} Welcome E-mail was resent`, { username });
      lgg.info(response);
      const result = { error: false, message: response.data.message };
      if (response.status !== StatusCodes.OK) {
        result.error = true;
      }
      return result;
    } catch (error) {
      lgg.error(`${LOG_TAG} Failed to resend Welcome E-mail`, {
        error,
        username
      });
      return { error: true, message: `${error}` };
    }
  }
};

const mutations = {
  SET_DATA(state: any, data: any) {
    state.data = data;
  },
  SELECT_ITEM(state: any, id: String) {
    state.selectedItem = state.selectedItem === id ? null : id;
  }
};

const store: any = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default store;
